import { GalleryDto } from '@nusign/picflow-backend-types';

export const includeIsLiked = (permissions: GalleryDto['permissions'], gallery: GalleryDto) => {
  return permissions.can_review_if_authenticated && gallery.enabled_feedback_options.includes('favourite');
};
